var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-alert',{attrs:{"type":_vm.type,"dismissible":false}},[(!_vm.isLoading)?_c('span',[_vm._v(_vm._s(_vm.availability)+" "+_vm._s(_vm.availability === 1 ? 'car' : 'cars')+" available for these dates")]):_c('span',[_vm._v("Getting availability...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }